import type { Lucid } from '../types/types';

// This function is only nessesary because we have internal links for lucidchart and lucidchart-blog in the same CMS
const prependInternalLink = (link: Lucid.Directus.Generated.Links, product: string): Lucid.Directus.Generated.Links => {
  const linkPath = link?.final_url;

  if (product === 'chartblog' && linkPath?.startsWith('/') && !link.final_url?.startsWith('/blog/')) {
    // This is an internal link to the lucidchart.com/pages website rather than the blog so we need to add the domain
    link.final_url = `https://www.lucidchart.com/pages${link.final_url}`;
  }

  return link;
};

export default prependInternalLink;
